import { iUserData } from './user.types';

export default class UserData implements iUserData {
  username: string;

  gamertag: string;

  email: string;

  password: string;

  constructor(
    username: string,
    gamertag: string,
    email: string,
    password: string,
  ) {
    this.username = username;
    this.gamertag = gamertag;
    this.email = email;
    this.password = password;
  }
}
